module.exports = __webpack_public_path__ + "static/media/phone.fd855142.svg";